import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/tokens.css';
import { App } from './app/App.jsx';
import { loadExtensions } from './lib/loadExtensions.js';

loadExtensions().then(extensions => {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <BrowserRouter basename={window.__BASE_PATH__ || "/"}>
        <App extensions={extensions} />
      </BrowserRouter>
    </StrictMode>
  );
});
